import React, { useEffect, useState } from "react";
import { Info } from "@phosphor-icons/react";
import { api } from "../../lib/api";

export const AnnouncementBar = () => {
  const [settings, setSettings] = useState({
    announcement_bar_text: "For research use only. Signature required at delivery on every order. Shipping calculated at checkout.",
    announcement_bar_active: true,
  });

  useEffect(() => {
    api.get("/site-settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  if (!settings.announcement_bar_active || !settings.announcement_bar_text) return null;

  return (
    <div
      data-testid="announcement-bar"
      className="w-full bg-brand-navy text-white"
    >
      <div className="mps-container py-2.5 flex items-center justify-center gap-2 text-[11px] md:text-xs text-white/90">
        <Info size={14} weight="regular" className="text-brand-accent" aria-hidden />
        <span className="tracking-wide font-medium">{settings.announcement_bar_text}</span>
      </div>
    </div>
  );
};
